module.exports = __webpack_public_path__ + "static/media/main idea.ab52425d.mp3";